import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const Footer = () => {
  const { settings } = useSettings();
  const c = settings?.contact || {};
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="container-pad py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl mb-3">Dr. Alonso Neto</div>
          <p className="text-sm text-primary-foreground/70 leading-relaxed">
            Médico Otorrinolaringologista CRM-MT 10.467 RQE 6533. Cuidado humanizado para toda a família.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-primary-foreground/50 mb-4">Navegação</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-accent">Início</Link></li>
            <li><Link to="/sobre" className="hover:text-accent">Sobre</Link></li>
            <li><Link to="/servicos" className="hover:text-accent">Serviços</Link></li>
            <li><Link to="/cirurgias" className="hover:text-accent">Cirurgias</Link></li>
            <li><Link to="/faq" className="hover:text-accent">FAQ</Link></li>
            <li><Link to="/contato" className="hover:text-accent">Contato</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-primary-foreground/50 mb-4">Contato</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" />{c.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 shrink-0" />{c.phone}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0" />{c.email}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-primary-foreground/50 mb-4">Redes Sociais</div>
          <div className="flex gap-3">
            {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:border-accent transition" data-testid="social-instagram"><Instagram className="w-4 h-4" /></a>}
            {c.youtube && <a href={c.youtube} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:border-accent transition" data-testid="social-youtube"><Youtube className="w-4 h-4" /></a>}
            {c.facebook && <a href={c.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:border-accent transition" data-testid="social-facebook"><Facebook className="w-4 h-4" /></a>}
            {c.linkedin && <a href={c.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:border-accent transition" data-testid="social-linkedin"><Linkedin className="w-4 h-4" /></a>}
          </div>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="container-pad py-5 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-primary-foreground/60">
          <div>© {new Date().getFullYear()} Dr. Alonso Neto — Todos os direitos reservados.</div>
          <div className="flex items-center gap-4">
            <span>Desenvolvido por <a href="https://senatech.com.br" target="_blank" rel="noreferrer" className="text-accent hover:underline font-medium" data-testid="footer-senatech">Sena Technology</a></span>
            <span className="text-primary-foreground/30">|</span>
            <Link to="/admin/login" className="hover:text-accent" data-testid="footer-admin-link">Painel Administrativo</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
